"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalTeamStencil = exports.externalTeamStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.externalTeamStencilDefinition = {
    view: {
        label: 'Non-Sponsored Team',
        category: 'group',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: ['title', 'header-media'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'logos',
                            'url',
                            'featured-media',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: ['location-of-nationality', 'participating-disciplines'],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone', 'no-monetization'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: { hasFeatureCardPreview: true },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.locationOfNationalityPropertyDefinition.name]: properties_1.locationOfNationalityPropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: {
            ...properties_1.noMonetizationPropertyDefinition,
            default: true,
        },
        [properties_1.participatingDisciplinesPropertyDefinition.name]: properties_1.participatingDisciplinesPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'racing-bulls',
        'redbull_com',
        'redbull-racing',
    ],
    name: 'external-team',
};
const isExternalTeamStencil = (stencil) => {
    return stencil.name === exports.externalTeamStencilDefinition.name;
};
exports.isExternalTeamStencil = isExternalTeamStencil;
//# sourceMappingURL=data:application/json;base64,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